import React, { type ReactNode } from "react";

/** The sand header band every metrics panel shares; children sit after the title. */
export function PanelHead({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) {
  return (
    <header className="flex min-h-12 flex-wrap items-center gap-x-4 gap-y-1 border-b border-border bg-muted px-[18px] py-2">
      <h2 className="text-body font-bold uppercase tracking-[0.08em] text-foreground">
        {title}
      </h2>
      {children}
    </header>
  );
}
